let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("25N5T")).then(() => parcelRequire('2jPVy'));